module.exports = __webpack_public_path__ + "img/MintPool_li_img.7942d396.png";